import api from '../services/api/index';

export interface VinScanResult {
  vinFound: boolean;
  confidence: number;
  vin: string;
}

export interface VinDecodeResult {
  make?: string;
  model?: string;
  year?: number;
  vehicleType?: string;
}

export interface VinScanRequest {
  imageData: string; // base64 encoded image data
}

export const vinScannerApi = {
  /**
   * Scan an image for VIN using the backend OpenAI integration
   */
  scanImage: async (imageData: string): Promise<VinScanResult> => {
    try {
      const response = await api.post('/vin-scanner/scan', {
        imageData
      });

      return response.data as VinScanResult;
    } catch (error) {
      console.error('VIN scan API error:', error);
      throw new Error('Failed to scan image for VIN');
    }
  },

  /**
   * Decode VIN to get vehicle information using NHTSA API
   */
  decodeVin: async (vin: string): Promise<VinDecodeResult> => {
    try {
      const response = await api.post('/vin-scanner/decode-vin', { vin });
      return response.data as VinDecodeResult;
    } catch (error) {
      console.error('VIN decode API error:', error);
      throw new Error('Failed to decode VIN');
    }
  }
};
